import AreYouSureModal from "components/modals/AreYouSureModal";
import Table from "components/Tables/Table";
import React from "react";

interface Props {
  aliases: server.dto.ContactAlias[]
  canModify: boolean
  onDeleted: () => Promise<unknown>
}

export const ContactAliasesTable = (props: Props) => {
  const [deleteAlias, setDeleteAlias] = React.useState<number | false>(false);

  const onContactAliasDelete = (alias: server.dto.ContactAlias) => {
    setDeleteAlias(alias.contactAliasId);
  }

  return <>
    <Table
      items={props.aliases}
      isLoading={false}
      getKey={alias => alias.contactAliasId.toString()}
      onDelete={onContactAliasDelete}
      canDelete={() => props.canModify}
      hideHeader
      columns={[
        {
          key: "name",
          header: "",
          render: (alias: server.dto.ContactAlias) => alias.name.fullName
        }
      ]}
    />
    {deleteAlias && <AreYouSureModal
      title={RESX.GeneralLabels.Delete}
      textContent={RESX.GeneralWarnings.DeleteSure}
      onClose={() => { setDeleteAlias(false); }}
      onYes={async () => {
        await window.CoreApi.ContactAlias.Delete({ contactAliasId: deleteAlias });
        setDeleteAlias(false);
        await props.onDeleted();
      }}
      yesButtonLabel={RESX.GeneralLabels.Delete}
      yesButtonColor="red"
    />}
  </>
}
